import { NavLink } from 'react-router-dom';

import type { SiteContent } from '../../content/types';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';
import { Container } from '../layout/container';
import { SectionHeading } from './section-heading';
import { FaqAccordion } from './faq-accordion';

interface FaqPreviewSectionProps {
  content: SiteContent;
}

export function FaqPreviewSection({ content }: FaqPreviewSectionProps): JSX.Element {
  const faqLabel = content.navigation.primary.find((item) => item.href === '/faq')?.label ?? content.faqSection.headline;

  return (
    <section className="py-12 sm:py-16">
      <Container className="space-y-8">
        <SectionHeading title={content.faqSection.headline} />
        <Card className="bg-white">
          <CardContent className="p-6">
            <FaqAccordion items={content.faqSection.items} maxItems={4} />
          </CardContent>
        </Card>
        <Button asChild variant="outline">
          <NavLink to="/faq">{faqLabel}</NavLink>
        </Button>
      </Container>
    </section>
  );
}
